<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-11 09:21:22
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\material\components\addOrEdit.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="75%" :destroy-on-close="true"
    :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>{{ materialData.id ? '编辑物料' : '新增物料' }}</div>
      <div>
        <el-button type="primary" @click="submit"> 保存 </el-button>
        <el-button plain @click="$emit('close')"> 返回 </el-button>
      </div>
    </div>
    <el-card class="udi-form group-box no-border" shadow="never">
      <el-form ref="form" :rules="rules" :model="form" label-width="160px">
        <el-form-item label="物料分组" prop="materialGroupId">
          <el-cascader v-model="form.materialGroupId"
            :props="{ checkStrictly: true, children: 'children', label: 'materialGroupName', value: 'materialGroupId' }"
            :options="categoryData" placeholder="请选择内容"></el-cascader>
        </el-form-item>
        <el-form-item label="物料名称" prop="materialName">
          <el-input v-model="form.materialName" maxlength="200" placeholder="请输入物料名称"></el-input>
        </el-form-item>
        <el-form-item label="物料编码" prop="materialCode">
          <el-input v-model="form.materialCode" :disabled="!!materialData.id" maxlength="50"
            placeholder="请输入物料编码"></el-input>
        </el-form-item>
        <el-form-item label="物料规格型号" prop="specification">
          <el-input v-model="form.specification" maxlength="500" placeholder="请输入规格型号"></el-input>
        </el-form-item>
        <el-form-item label="货号" prop="itemNo">
          <el-input v-model="form.itemNo" maxlength="50" placeholder="请输入货号"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="baseUnit">
          <el-input v-model="form.baseUnit" maxlength="50" placeholder="请输入单位"></el-input>
        </el-form-item>
        <el-form-item label="存储温度" prop="storageTemperature">
          <el-input v-model="form.storageTemperature" maxlength="10" placeholder="请输入存储温度"></el-input>
        </el-form-item>
        <el-form-item label="目录价" prop="listPrice">
          <el-input v-model="form.listPrice" maxlength="10" placeholder="请输入目录价"></el-input>
        </el-form-item>
        <el-form-item label="促销价" prop="promotionPrice">
          <el-input v-model="form.promotionPrice" maxlength="10" placeholder="请输入促销价"></el-input>
        </el-form-item>
        <el-form-item label="有效期" prop="time">
          <el-input v-model="form.time" maxlength="10" placeholder="请输入有效期"></el-input>
        </el-form-item>
        <el-form-item label="有效期单位" prop="unit">
          <el-input v-model="form.unit" maxlength="10" placeholder="请输入有效期单位"></el-input>
        </el-form-item>
        <el-form-item label="是否禁用" prop="forbidStatus">
          <el-radio-group v-model="form.forbidStatus">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </el-card>
  </el-drawer>
</template>

<script>
import { handleTree, findParent, findNode } from '@/utils/ruoyi.js'
import {
  saveOrUpdateMaterial,
  getMaterialCategory,
  getMaterialInfo
} from '@/api/material'
export default {
  name: 'AddOrEditMaterial',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    materialData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      categoryData: [],
      form: {},
      rules: {
        materialGroupId: [
          {
            required: true,
            message: '请选择物料分组',
            trigger: ['change', 'blur']
          }
        ],
        materialName: [
          {
            required: true,
            message: '请输入物料名称',
            trigger: ['change', 'blur']
          }
        ],
        materialCode: [
          {
            required: true,
            message: '请输入物料编码',
            trigger: ['change', 'blur']
          }
        ],
        specification: [
          {
            required: true,
            message: '请输入规格型号',
            trigger: ['change', 'blur']
          }
        ],
        promotionPrice: [
          {
            pattern: /^([1-9]\d*\.?\d{1,2}|[1-9]\d*|0)$/,
            message: '仅能输入数字且最多保留两位小数',
            trigger: ['change', 'blur']
          }
        ],
        listPrice: [
          {
            pattern: /^([1-9]\d*\.?\d{1,2}|[1-9]\d*|0)$/,
            message: '仅能输入数字且最多保留两位小数',
            trigger: ['change', 'blur']
          }
        ],
        forbidStatus: [
          {
            required: true,
            message: '请选择是否禁用',
            trigger: ['change', 'blur']
          }
        ],

      }
    }
  },
  created() {
    this.getMaterialCategory()
  },
  // 方法集合
  methods: {
    // 获取物料信息
    getMaterialInfo(id) {
      this.loading = true
      if (id) {
        getMaterialInfo(id).then((res) => {
          this.form = res.data
          let result = []
          findParent(this.categoryData, { materialGroupId: this.form.materialGroupId }, result, 'materialGroupId')
          delete this.form.updateTime
          delete this.form.updatedTime
          this.form.materialGroupId = result
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.form = Object.assign(this.$data.form, this.$options.data.call(this)).form
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
        this.loading = false
      }
    },
    // 获取物料分组
    getMaterialCategory() {
      getMaterialCategory({}).then((res) => {
        this.categoryData = handleTree(res.data, 'materialGroupId', 'parentMaterialGroupId')
        this.getMaterialInfo(this.materialData.id)
      })
    },
    // 保存
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        const params = JSON.parse(JSON.stringify(this.form));
        params.materialGroupId = params.materialGroupId[this.form.materialGroupId.length - 1]
        const { materialGroupName, materialGroupCode } = findNode(this.categoryData, params.materialGroupId, 'materialGroupId') || {}
        params.materialGroupName = materialGroupName
        params.materialGroupCode = materialGroupCode
        saveOrUpdateMaterial(params).then(() => {
          this.$emit('close')
        })
      })
    }
  }
}
</script>
<style scoped>
.grid-box>>>.el-form-item .el-form-item__label {
  line-height: 2.5 !important;
}
</style>
